import { FormField, Select, SelectProps } from 'zens-storybook'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet } from 'react-native'
import { User } from 'zens-store'

const styles = StyleSheet.create({
  container: {
    minHeight: 110,
  },
  input: {
    maxWidth: 400,
  },
})

interface Props extends Omit<SelectProps<number>, 'error'> {
  error?: string
  user?: User
}
const Location = (props: Props) => {
  const { style, error, ...otherProps } = props
  const { t } = useTranslation()
  const items = [
    {
      key: 'all',
      title: t('All locations'),
      value: undefined,
    },
  ]
  return (
    <FormField
      label={t('Location access')}
      help={t('Defining the company locations a user has access to in the application')}
      style={[styles.container, style]}
      error={error}
    >
      <Select items={items} style={styles.input} error={!!error} testID="UserLocation.Select" {...otherProps} />
    </FormField>
  )
}

export default Location
